
import {makePeriod} from '../../cards-defs'

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  methods: {
    makePeriod(start, end){
      return makePeriod(start, end)
    },
  }
}
